/**
 * Re-export of the shared CustomHTML component for the storefront renderer.
 * The base component (render + fields + defaults) lives in
 * `@launchstore/shared-puck`. The renderer uses it as-is — no
 * editor-specific field widgets.
 *
 * See launchstore-shared/src/puck/components/homepage/CustomHTML/ for source.
 */
import { CustomHTML as SharedCustomHTML } from '@launchstore/shared-puck';

export const CustomHTML: any = SharedCustomHTML;
export type { CustomHTMLProps } from '@launchstore/shared-puck';
export default CustomHTML;
